import angular from 'angular';

(function() {
    angular.module('app.core').factory('CompanyFilter', CompanyFilterData);

    ('use strict');
    angular.module('app.core').factory('CompanyFilter', CompanyFilterData);

    CompanyFilterData.$inject = [];

    /* @ngInject */
    function CompanyFilterData() {
        CompanyFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            setPrincipalEid: setPrincipalEid,
            setCompanyId: setCompanyId,
            getPrincipalEid: getPrincipalEid,
            getCompanyId: getCompanyId
        };

        function CompanyFilter(companyFilterData) {
            if (!companyFilterData) {
                this.buildEmpty();
            } else {
                this.build(companyFilterData);
            }
        }

        return CompanyFilter;

        /////////////////////

        function buildEmpty() {
            this.principalEid = null;
            this.principalName = null;
            this.companyId = null;
            this.companyName = null;
            this.companyCountry = null;
        }

        function build(companyFilter) {
            this.principalEid = companyFilter.principalEid || null;
            this.principalName = companyFilter.principalName || null;
            this.companyId = companyFilter.companyId || null;
            this.companyName = companyFilter.companyName || null;
            this.companyCountry = companyFilter.companyCountry || null;
        }
    }

    function setPrincipalEid(principalEid) {
        this.principalEid = principalEid;
    }

    function getPrincipalEid() {
        return this.principalEid;
    }

    function setCompanyId(companyId) {
        this.companyId = companyId;
    }

    function getCompanyId() {
        return this.companyId;
    }
})();
